// @ts-nocheck
(function () {
  'use strict';
  window.AIFlorist = window.AIFlorist || {};

  function build(root, options) {
    var uiChrome = (options && options.uiChrome) || {};
    var logoUrl = (options && options.logoUrl) || '/assets/aifloristlogo-transparent.png';
    var defaultTitle = (options && options.defaultTitle) || 'Chat with Fleur';

    root.innerHTML =
      '<div class="afc">' +
        '<div class="afc-drawer-overlay" id="afc-drawer-overlay"></div>' +
        '<div class="afc-drawer" id="afc-drawer">' +
          '<div class="afc-drawer-header">' +
            '<span class="afc-drawer-title">' + (uiChrome.pastChats || 'Past Chats') + '</span>' +
            '<button class="afc-drawer-close" id="afc-drawer-close" aria-label="' + (uiChrome.closeHistory || 'Close history') + '">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<line x1="18" y1="6" x2="6" y2="18"></line>' +
                '<line x1="6" y1="6" x2="18" y2="18"></line>' +
              '</svg>' +
            '</button>' +
          '</div>' +
          '<div class="afc-drawer-list" id="afc-drawer-list">' +
            '<div class="afc-drawer-empty">' + (uiChrome.noPastConversations || 'No past conversations yet') + '</div>' +
          '</div>' +
          '<div class="afc-drawer-footer">' +
            '<button class="afc-drawer-forget-btn" id="afc-forget-btn">' + (uiChrome.forgetMe || 'Forget me & delete my data') + '</button>' +
          '</div>' +
        '</div>' +
        '<header class="afc-header">' +
          '<div class="afc-logo">' +
            '<img class="afc-logo-image" src="' + logoUrl + '" alt="AI Florist logo" width="48" height="48" loading="eager" decoding="async" />' +
            '<span id="afc-chat-title">' + defaultTitle + '</span>' +
          '</div>' +
          '<div class="afc-header-actions">' +
            '<button class="afc-header-btn" id="afc-flowerlib-btn" aria-label="' + (uiChrome.flowerLibrary || 'Flower library') + '" title="' + (uiChrome.browseFlowerLibrary || 'Browse flower library') + '">' +
              '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<circle cx="12" cy="12" r="2"></circle>' +
                '<circle cx="12" cy="7.5" r="2.5"></circle>' +
                '<circle cx="15.9" cy="9.8" r="2.5"></circle>' +
                '<circle cx="15.9" cy="14.2" r="2.5"></circle>' +
                '<circle cx="12" cy="16.5" r="2.5"></circle>' +
                '<circle cx="8.1" cy="14.2" r="2.5"></circle>' +
                '<circle cx="8.1" cy="9.8" r="2.5"></circle>' +
              '</svg>' +
            '</button>' +
            '<button class="afc-header-btn" id="afc-history-btn" aria-label="' + (uiChrome.chatHistory || 'Chat history') + '" title="' + (uiChrome.pastChats || 'Past Chats') + '">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<circle cx="12" cy="12" r="10"></circle>' +
                '<polyline points="12 6 12 12 16 14"></polyline>' +
              '</svg>' +
            '</button>' +
            '<button class="afc-header-btn" id="afc-newchat-btn" aria-label="' + (uiChrome.newChat || 'New chat') + '" title="' + (uiChrome.startNewChat || 'Start new chat') + '">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<line x1="12" y1="5" x2="12" y2="19"></line>' +
                '<line x1="5" y1="12" x2="19" y2="12"></line>' +
              '</svg>' +
            '</button>' +
          '</div>' +
        '</header>' +
        '<main class="afc-messages" id="afc-messages"></main>' +
        '<div class="afc-preview-bar" id="afc-preview-bar" style="display:none;">' +
          '<div class="afc-preview-thumbs" id="afc-preview-thumbs"></div>' +
        '</div>' +
        '<div class="afc-preview-multi" id="afc-preview-multi"></div>' +
        '<div id="afc-consent-slot"></div>' +
        '<footer class="afc-input-area">' +
          '<div class="afc-reply-slot" id="afc-reply-slot"></div>' +
          '<form class="afc-form" id="afc-form">' +
            '<input type="file" id="afc-file-input" accept="image/jpeg,image/png,image/webp,image/gif" multiple style="display:none;" />' +
            '<button type="button" class="afc-upload-btn" id="afc-upload-btn" aria-label="' + (uiChrome.attachImage || 'Attach image') + '" title="' + (uiChrome.attachImage || 'Attach image') + '">' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>' +
                '<circle cx="8.5" cy="8.5" r="1.5"></circle>' +
                '<polyline points="21 15 16 10 5 21"></polyline>' +
              '</svg>' +
            '</button>' +
            '<textarea class="afc-input" id="afc-input" placeholder="' + (uiChrome.inputPlaceholder || 'Describe your dream bouquet...') + '" autocomplete="off" maxlength="1000" rows="1"></textarea>' +
            '<button type="submit" class="afc-send" id="afc-send" aria-label="Send message">' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<line x1="22" y1="2" x2="11" y2="13"></line>' +
                '<polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>' +
              '</svg>' +
            '</button>' +
          '</form>' +
        '</footer>' +
      '</div>';

    return {
      messagesEl: document.getElementById('afc-messages'),
      formEl: document.getElementById('afc-form'),
      inputEl: document.getElementById('afc-input'),
      sendBtn: document.getElementById('afc-send'),
      titleEl: document.getElementById('afc-chat-title'),
      uploadBtn: document.getElementById('afc-upload-btn'),
      fileInput: document.getElementById('afc-file-input'),
      previewBar: document.getElementById('afc-preview-bar'),
      replySlotEl: document.getElementById('afc-reply-slot'),
    };
  }

  window.AIFlorist.shell = {
    build: build,
  };
})();
